export const getCoworkerCategory = (config, name) => {
  const categories = config.coworkerCategories || [];
  return categories.find(item => item.nameIdentifier === name);
};
